<!--
Vuetify の data-table コンポーネントをDjango Rest Framework に対応させる Mixin

利用するには、v-data-tableのattrに以下を設定
      :pagination.sync="pagination"
      :total-items="pagination.totalItems"

検索を利用する場合は、search変数をv-modelに設定
-->
<script>
import _ from 'lodash'

export default {
    data: () => ({
      pagination: { descending: false, page: 1, rowsPerPage: 10, sortBy: null },
      search: null
    }),
    watch: {
      'pagination.descending' () { this.getListWatchDebounce() },
      'pagination.page' () { this.getListWatchDebounce() },
      'pagination.rowsPerPage' () { this.getListWatchDebounce() },
      'pagination.sortBy' () { this.getListWatchDebounce() },
      search () {
        this.getListDebounce()
      }
    },
    methods: {
      syncPagination({ page, itemsPerPage, sortBy }) {
        this.pagination.page = page
        this.pagination.rowsPerPage = itemsPerPage
        if (sortBy.length === 0) {
          this.pagination.sortBy = null
          this.pagination.descending = false
        } else {
          // created_at_unix
          if (sortBy[0].key === 'created_at_unix') {
            this.pagination.sortBy = 'created_at'
          } else if (sortBy[0].key === 'deleted_at_unix') {
            this.pagination.sortBy = 'deleted_at'
          } else {
            this.pagination.sortBy = sortBy[0].key
          }
          this.pagination.descending = sortBy[0].order === 'desc'
        }
      },
      getSyncParams () {
        let params = {}
        params.limit = this.pagination.rowsPerPage
        params.offset = this.pagination.rowsPerPage * this.pagination.page - this.pagination.rowsPerPage
        if (this.pagination.descending === true) {
          params.ordering = '-' + this.pagination.sortBy
        } else {
          params.ordering = this.pagination.sortBy
        }
        params.search = this.search
        return params
      },
      applySyncData (res) {
        this.pagination.totalItems = res.data.count
      },
      // キーボード連続入力に対する遅延クエリ
      getListDebounce: _.debounce(function () {
        this.getList()
      }, 1000),
      // Watch乱発にならないように遅延クエリ
      getListWatchDebounce: _.debounce(function () {
        this.getList()
      }, 300)
    }
  }
</script>
